var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.groupClass },
    [
      _vm.showContent ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _vm.addAsButton && _vm.multi
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addButtonShowCondition,
                  expression: "addButtonShowCondition",
                },
              ],
              staticClass: "row",
            },
            [
              _c("div", { staticClass: "card col-12 mb-0" }, [
                _c("div", { staticClass: "card-body px-5" }, [
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-6 col-12 text-center need-additional-banner",
                      },
                      [
                        _c("h3", { staticClass: "bold" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("application.needToAddAdditional", {
                                  additionalTarget: _vm.pluralizeGroupName,
                                })
                              ) +
                              "?\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary d-md-inline d-block text-md-left text-center w-md-auto w-100",
                            attrs: {
                              type: "button",
                              disabled: _vm.disabled,
                              path: _vm.path,
                              tabindex: _vm.tabindex,
                            },
                            on: {
                              click: _vm.add,
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.add.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("application.addAdditional", {
                                    additionalTarget: _vm.singularizeGroupName,
                                  })
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _c("div", { staticClass: "mt-3 d-flex" }, [
            _vm.showAdditionsAmount
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.amountOfAdditions,
                        expression: "amountOfAdditions",
                      },
                    ],
                    staticClass:
                      "drop-down-additions form-control material-input py-0 form my-1 moregage-data select-field",
                    attrs: { name: "type", tabindex: _vm.tabindex },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.amountOfAdditions = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.dropDownItemsSize, function (index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: index } },
                      [_vm._v("\n        " + _vm._s(index) + "\n      ")]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.multi
              ? _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.addButtonShowCondition,
                        expression: "addButtonShowCondition",
                      },
                    ],
                    staticClass: "clickable btn-sm btn-primary d-block",
                    class: { disabled: _vm.disabled },
                    style: { paddingTop: "7px!important", marginLeft: "5px" },
                    attrs: { path: _vm.path, tabindex: _vm.tabindex },
                    on: {
                      click: _vm.add,
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.add.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      +\n      " +
                        _vm._s(
                          _vm.$t("application.addDynamic", {
                            addTitle: _vm.addTitle,
                            additionalTarget: _vm.singularizeGroupName,
                          })
                        ) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }